// Additional SEO utilities and optimizations
export const addMetaTags = (tags) => {
  tags.forEach(tag => {
    const meta = document.createElement('meta');
    Object.keys(tag).forEach(key => {
      meta.setAttribute(key, tag[key]);
    });
    document.head.appendChild(meta);
  });
};

// Critical CSS injection for above-the-fold content
export const injectCriticalCSS = () => {
  const criticalCSS = `
    /* Critical above-the-fold styles */
    .header { position: fixed; top: 0; left: 0; right: 0; z-index: 1000; }
    .hero { min-height: 100vh; display: flex; align-items: center; }
    .hero__title { font-size: clamp(2rem, 5vw, 4rem); font-weight: 700; }
    .hero__description { font-size: 1.125rem; line-height: 1.6; }
    .skip-link { position: absolute; top: -40px; left: 6px; }
  `;
  
  const style = document.createElement('style');
  style.textContent = criticalCSS;
  document.head.appendChild(style);
};

// Optimize images with lazy loading
export const optimizeImages = () => {
  const images = document.querySelectorAll('img[data-src]');
  
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.remove('lazy');
        observer.unobserve(img);
      }
    });
  });
  
  images.forEach(img => imageObserver.observe(img));
};

// Add breadcrumb navigation
export const addBreadcrumbs = (breadcrumbs) => {
  const breadcrumbContainer = document.createElement('nav');
  breadcrumbContainer.setAttribute('aria-label', 'Breadcrumb');
  breadcrumbContainer.className = 'breadcrumbs';
  
  const ol = document.createElement('ol');
  ol.className = 'breadcrumb-list';
  
  breadcrumbs.forEach((crumb, index) => {
    const li = document.createElement('li');
    li.className = 'breadcrumb-item';
    
    if (index < breadcrumbs.length - 1) {
      const a = document.createElement('a');
      a.href = crumb.url;
      a.textContent = crumb.name;
      li.appendChild(a);
    } else {
      li.setAttribute('aria-current', 'page');
      li.textContent = crumb.name;
    }
    
    ol.appendChild(li);
  });
  
  breadcrumbContainer.appendChild(ol);
  return breadcrumbContainer;
};

// Social media meta tags generator
export const generateSocialMeta = (data) => {
  return [
    // Open Graph
    { property: 'og:title', content: data.title },
    { property: 'og:description', content: data.description },
    { property: 'og:image', content: data.image },
    { property: 'og:url', content: data.url },
    { property: 'og:type', content: 'website' },
    { property: 'og:site_name', content: 'Roots of Northeast' },
    
    // Twitter
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: data.title },
    { name: 'twitter:description', content: data.description },
    { name: 'twitter:image', content: data.image },
    
    // LinkedIn
    { property: 'linkedin:owner', content: 'Roots of Northeast' },
    
    // Additional SEO
    { name: 'application-name', content: 'Roots of Northeast' },
    { name: 'msapplication-TileColor', content: '#2563eb' },
    { name: 'theme-color', content: '#2563eb' }
  ];
};

// Generate local business schema
export const generateLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Roots of Northeast",
  "image": "https://rotsnortheast.com/logo.png",
  "telephone": "+91-91016-33479",
  "email": "info@rotsnortheast.com",
  "address": {
    "@type": "PostalAddress",
    "addressRegion": "Northeast India",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "26.2006",
    "longitude": "92.9376"
  },
  "url": "https://rotsnortheast.com",
  "openingHours": "Mo-Fr 09:00-18:00",
  "priceRange": "$$",
  "currenciesAccepted": "INR",
  "paymentAccepted": "Cash, Credit Card, Bank Transfer"
});

// Performance optimization hints
export const addResourceHints = () => {
  const hints = [
    { rel: 'dns-prefetch', href: '//fonts.googleapis.com' },
    { rel: 'dns-prefetch', href: '//www.google-analytics.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: 'anonymous' },
    { rel: 'prefetch', href: '/api/contact' },
    { rel: 'prefetch', href: '/images/testimonials' }
  ];
  
  hints.forEach(hint => {
    const link = document.createElement('link');
    Object.keys(hint).forEach(key => {
      if (key === 'crossorigin') {
        link.crossOrigin = hint[key];
      } else {
        link.setAttribute(key, hint[key]);
      }
    });
    document.head.appendChild(link);
  });
};